import { SelectableValue } from "./selectable-value";

export const userRoleLabels: any = {
	OWNER: "owner",
	APPROVER: "approver",
	EDITOR: "editor",
	FULL_ACCESS_USER: "full_access_user",
	LIMITED_ACCESS_USER: "limited_access_user",
};

export const simulatorRoles = [
	{ value: "OWNER", label: "simulator-user-role-owner" },
	{ value: "EDITOR", label: "simulator-user-role-editor" },
	{ value: "VIEWER", label: "simulator-user-role-viewer-limited" },
	{ value: "NON_VIEWER", label: "simulator-user-role-non-viewer" },
];

export const userRoleDescriptions: { [key: string]: string } = {
	OWNER: "agreement-user-role-description-OWNER",
	APPROVER: "agreement-user-role-description-APPROVER",
	EDITOR: "agreement-user-role-description-EDITOR",
	FULL_ACCESS_USER: "agreement-user-role-description-FULL_ACCESS_USER",
	LIMITED_ACCESS_USER: "agreement-user-role-description-LIMITED_ACCESS_USERs",
};

export const agreementTagLabels: any = {
	SLL: "SLL",
	ARTICLE_71: "Article-71",
	CUSTOM: "CUSTOM",
	VOLUME_BASED: "VOLUME_BASED",
};

export const roles: Array<SelectableValue> = [
	{ value: "OWNER", label: "Owner" } as SelectableValue,
	{ value: "APPROVER", label: "Approver" } as SelectableValue,
	{ value: "EDITOR", label: "Editor" } as SelectableValue,
	{ value: "FULL_ACCESS_USER", label: "Viewer with Full access" } as SelectableValue,
	{ value: "LIMITED_ACCESS_USER", label: "Viewer with limited access" } as SelectableValue,
];

export const assigneeStatusLabels: any = {
	YES_ALWAYS: "yes_always",
	YES_WHEN_CREATOR: "yes_when_creator",
	NO: "no",
};

export const assigneeStatusDescriptions: { [key: string]: string } = {
	YES_ALWAYS: "yes_always_description",
	YES_WHEN_CREATOR: "yes_when_creator_description",
	NO: "no_description",
};

export const assigneeStatuses: Array<SelectableValue> = [
	{ value: "YES_ALWAYS", label: "Yes, always" } as SelectableValue,
	{ value: "YES_WHEN_CREATOR", label: "Yes, when creator" } as SelectableValue,
	{ value: "NO", label: "No" } as SelectableValue,
];
